module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": "text",
      "heading": 'Details for ' + _vm.rowData.name,
      "button-text": "Charts",
      "button-size": "mini",
      "show-save": false,
      "button-icon": "fa fa-chart-pie"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('op-stats', {
    attrs: {
      "stats": _vm.rowData,
      "org-id": _vm.rowData.organisation_id
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.hasSites) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": _vm.hasRequests ? 10 : 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Sites")])]), _vm._v(" "), _c('sites-chart', {
    attrs: {
      "stats": _vm.rowData
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasRequests) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": _vm.hasSites ? 14 : 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" Requests")])]), _vm._v(" "), _c('requests-chart', {
    attrs: {
      "stats": _vm.rowData
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d37e82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/PopupSharerStats.vue
// module id = 1348
// module chunks = 0